import React, { useState } from 'react';
import { Button } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import BugReportModal from './BugReportModal';
import './ReportIssueButton.css';

const ReportIssueButton = ({ user, operator, setOperator, breadcrumbs, isAdmin, messageApi }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [recordingUrl, setRecordingUrl] = useState('');

  const handleModalClose = () => {
        setIsModalVisible(false);
    setRecordingUrl(''); // Clear recording URL when modal closes
  };

  const handleRecordingComplete = (url) => {
    setRecordingUrl(url);
    setIsModalVisible(true); // Reopen modal after recording
  };

  return (
    <>
      <Button
        type="primary"
        icon={<BugOutlined />}
        onClick={() => setIsModalVisible(true)}
        className="report-issue-floating-button"
        style={{
          position: 'fixed',
          bottom: '80px',
          right: '20px',
          zIndex: 1002,
          width: '50px',
          height: '50px',
                        borderRadius: '50%', 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none',
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                    transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
          fontSize: '20px'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-2px) scale(1.05)';
          e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0) scale(1)';
          e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
        }}
      />

      <BugReportModal
        visible={isModalVisible}
        onClose={handleModalClose}
        user={user}
        operator={operator}
        setOperator={setOperator}
        breadcrumbs={breadcrumbs}
        isAdmin={isAdmin}
        messageApi={messageApi}
        recordingUrl={recordingUrl}
        onRecordingComplete={handleRecordingComplete}
      />
    </>
  );
};

export default ReportIssueButton; 
